module.exports = __webpack_public_path__ + "static/media/person-using-concierge.9823811a.jpg";